import React from 'react';
import { getLoginUrl } from '../utils/config';
import './Pricing.css';

interface Plan {
  name: string;
  price: string;
  period: string;
  description: string;
  features: string[];
  popular?: boolean;
  ctaText: string;
  ctaDescription: string;
}

const plans: Plan[] = [
  {
    name: 'Starter',
    price: 'R$ 99',
    period: '/mês',
    description: 'Perfeito para times pequenos começando a medir performance',
    features: [
      'Membros ilimitados',
      'Até 5 repositórios',
      'Até 10 desenvolvedores',
      'Todas as métricas',
      'Suporte por email'
    ],
    ctaText: 'Testar Grátis',
    ctaDescription: 'Experimente grátis por 90 dias, não requer cartão de crédito.'
  },
  {
    name: 'Pro',
    price: 'R$ 24',
    period: '/mês por dev',
    description: 'Para times que precisam de insights completos',
    features: [
      'Todas as features do Starter +',
      'Repositórios ilimitados',
      'Desenvolvedores ilimitados',
      'Todas as métricas avançadas',
      'Relatórios automáticos por email',
      'Suporte prioritário'
    ],
    popular: true,
    ctaText: 'Testar Grátis',
    ctaDescription: 'Experimente grátis por 90 dias, não requer cartão de crédito.'
  },
  {
    name: 'Enterprise',
    price: 'Personalizado',
    period: '',
    description: 'Solução customizada para grandes organizações',
    features: [
      'Tudo do plano Pro +',
      'SLA garantido',
      'Onboarding dedicado',
      'Customizações',
      'Suporte 24/7',
      'Treinamento do time',
      'Integrações customizadas'
    ],
    ctaText: 'Falar com Vendas',
    ctaDescription: ''
  }
];

export const Pricing: React.FC = () => {
  const handleCtaClick = (planName: string) => {
    if (planName === 'Enterprise') {
      // Para Enterprise, poderia abrir um modal ou redirecionar para contato
      window.location.href = 'mailto:contato@opsight.com?subject=Interesse no plano Enterprise';
    } else {
      window.location.href = getLoginUrl();
    }
  };

  return (
    <section id="pricing" className="pricing-section">
      <div className="pricing-container">
        <div className="pricing-header">
          <h2 className="pricing-title">Planos que crescem com você</h2>
          <p className="pricing-subtitle">
            Escolha o plano ideal para suas necessidades. Todos os planos incluem atualizações automáticas.
          </p>
        </div>
        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`pricing-card ${plan.popular ? 'popular' : ''}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {plan.popular && (
                <div className="popular-badge">Mais Popular</div>
              )}
              <div className="pricing-card-header">
                <h3 className="plan-name">{plan.name}</h3>
                <div className="plan-price">
                  <span className="price-value">{plan.price}</span>
                  {plan.period && <span className="price-period">{plan.period}</span>}
                </div>
                <p className="plan-description">{plan.description}</p>
              </div>
              <ul className="plan-features">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>
                    <span className="feature-check">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              <button
                className={`plan-cta ${plan.popular ? 'cta-primary' : 'cta-secondary'}`}
                onClick={() => handleCtaClick(plan.name)}
              >
                {plan.ctaText}
              </button>
              <p className="pricing-btn-subtitle">
                {plan.ctaDescription}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};









